import { TRUSTED_BY } from '@/content/social-proof';
import { useT } from '@/lib/useLang';

/**
 * Les logos de vrais clients, juste sous le hero. Trois logos ne défilent pas :
 * une rangée fixe, centrée. Masquée tant que `TRUSTED_BY` est vide. Voir
 * `content/social-proof.ts`.
 */
export function TrustedBy() {
  const t = useT();
  if (TRUSTED_BY.length === 0) return null;

  return (
    <section className="nz-trusted">
      <div className="nz-container">
        <div className="nz-eyebrow">{t.clientsTrust}</div>
        <ul className="nz-trusted__list">
          {TRUSTED_BY.map((logo) => (
            <li key={logo.name}>
              {logo.src ? (
                <img
                  className="nz-trusted__img"
                  src={logo.src}
                  alt={logo.name}
                  style={
                    logo.scale
                      ? { height: `calc(var(--nz-trusted-h) * ${logo.scale})` }
                      : undefined
                  }
                />
              ) : (
                logo.name
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
